// Theme.js

import { createTheme } from '@mui/material/styles';
//import { green, purple } from '@mui/material/colors';

const theme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                /*
                "*": {
                    boxSizing: "border-box",
                    margin: 0,
                    padding: 0
                },
                */
                html: {
                    height: "100%",
                    width: "100%"
                },
                body: {
                    height: "100%",
                    width: "100%"
                },
                "#root": {
                    height: "100%",
                    width: "100%"
                }
            }
        },
        /*
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    margin: "0 20px",
                    borderRadius: 4,
                    "&:last-child": {
                        padding: "20px 0"
                    }
                },
                spacer: {
                    flex: "1 1 100%"
                }
            }
        },
        */
        /*
        MuiButton: {
            variants: [
                {
                    props: { variant: 'dashed' },
                    style: {
                        textTransform: 'none',
                        border: `2px dashed ${blue[500]}`,
                    },
                },
                {
                    props: { variant: 'dashed', color: 'secondary' },
                    style: {
                        border: `4px dashed ${red[500]}`,
                    },
                },
            ],
        },
        */
    },
    /*
    palette: {
        primary: {
            main: purple[500],
            //main: "#161616"
        },
        secondary: {
            main: green[500],
            //main: "#EEFD53"
        },
        error: {
            main: "#DA1E28"
        }
    },
    */
    /*
    typography: {
        fontFamily: [ "Noto Sans KR", "sans-serif", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue" ].join(",")
        //,fontSize: 11
    }
    */
});

export default theme;

export const colorTheme = createTheme({
    palette: {
        ochre: {
            main: '#e3d026',
            light: '#e9db5d',
            dark: '#a29415',
            contrastText: '#242105',
        },
        red: {
            main: '#f44336',
            light: '#e57373',
            dark: '#d32f2f',
            contrastText: '#ffffff',
        },
        pink: {
            main: '#e91e63',
            light: '#f06292',
            dark: '#c2185b',
            contrastText: '#ffffff',
        },
        purple: {
            main: '#9c27b0',
            light: '#ba68c8',
            dark: '#7b1fa2',
            contrastText: '#ffffff',
        },
        deepPurple: {
            main: '#673ab7',
            light: '#9575cd',
            dark: '#512da8',
            contrastText: '#ffffff',
        },
        indigo: {
            main: '#3f51b5',
            light: '#7986cb',
            dark: '#303f9f',
            contrastText: '#ffffff',
        },
        blue: {
            main: '#2196f3',
            light: '#64b5f6',
            dark: '#1976d2',
            contrastText: '#ffffff',
        },
        lightBlue: {
            main: '#03a9f4',
            light: '#4fc3f7',
            dark: '#0288d1',
            contrastText: '#ffffff',
        },
        cyan: {
            main: '#00bcd4',
            light: '#4dd0e1',
            dark: '#0097a7',
            contrastText: '#ffffff',
        },
        teal: {
            main: '#009688',
            light: '#4db6ac',
            dark: '#00796b',
            contrastText: '#ffffff',
        },
        green: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: '#ffffff',
        },
        lightGreen: {
            main: '#8bc34a',
            light: '#aed581',
            dark: '#689f38',
            contrastText: '#ffffff',
        },
        lime: {
            main: '#cddc39',
            light: '#dce775',
            dark: '#afb42b',
            contrastText: '#ffffff',
        },
        yellow: {
            main: '#ffeb3b',
            light: '#fff176',
            dark: '#fbc02d',
            contrastText: '#ffffff',
        },
        amber: {
            main: '#ffc107',
            light: '#ffd54f',
            dark: '#ffa000',
            contrastText: '#ffffff',
        },
        orange: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: '#ffffff',
        },
        deepOrange: {
            main: '#ff5722',
            light: '#ff8a65',
            dark: '#e64a19',
            contrastText: '#ffffff',
        },
        brown: {
            main: '#795548',
            light: '#a1887f',
            dark: '#5d4037',
            contrastText: '#ffffff',
        },
        grey: {
            main: '#9e9e9e',
            light: '#e0e0e0',
            dark: '#616161',
            contrastText: '#ffffff',
        },
        blueGrey: {
            main: '#607d8b',
            light: '#90a4ae',
            dark: '#455a64',
            contrastText: '#ffffff',
        },
    },
});


